import { DockviewApi, DockviewPanelApi } from "dockview-react";
import React from "react";
import { addFloatingPanel } from "./utils/DockerviewSettings";
import { useNavigate } from "react-router-dom";
import { BottomRevealTray } from "./BottomMenu";
import ReactDOM from "react-dom";
import Modal from "react-modal";

Modal.setAppElement("#root");

const Main = (props: { api: DockviewPanelApi; containerApi: DockviewApi }) => {
  const navigate = useNavigate();
  const isFullAccess = (localStorage.getItem("token") ?? "").startsWith("B8NyY");

  return (
    <div className="h-full w-full p-4 pb-16 flex items-start gap-5 overflow-y-auto">
      <div>
        <h1>Functions</h1>
        <nav>
          <ul>
            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/auth");
                }}
              >
                &gt; Auth
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "documentation", {});
                }}
              >
                &gt; Documentation
              </a>
            </li>

            {isFullAccess && (
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/mobile");
                  }}
                >
                  &gt; Mobile Layout
                </a>
              </li>
            )}

            <Break />

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "equity_chart", {});
                }}
              >
                &gt; Equity chart
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "realtime_chart", {});
                }}
              >
                &gt; Real-time chart
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "option_table_hf", {});
                }}
              >
                &gt; NBBO option chart
              </a>
            </li>

            {isFullAccess && (
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    addFloatingPanel(props.containerApi, "watchlist", {});
                  }}
                >
                  &gt; Watchlist
                </a>
              </li>
            )}

            {isFullAccess && (
              <li>
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    addFloatingPanel(props.containerApi, "extended_watchlist", {});
                  }}
                >
                  &gt; Extended Watchlist
                </a>
              </li>
            )}

            <Break />

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(
                    props.containerApi,
                    "options_definitions",
                    {},
                  );
                }}
              >
                &gt; Options definitions
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "opt_pricing_model", {});
                }}
              >
                &gt; Opt. pricing model
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "option_sovler", {});
                }}
              >
                &gt; Option solver
              </a>
            </li>

            {isFullAccess && (
              <>
                <Break />
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "kk7766posts", {});
                    }}
                  >
                    &gt; Posts
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "kk7766", {});
                    }}
                  >
                    &gt; Comments
                  </a>
                </li>
              </>
            )}

            <Break />

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "news_search", {});
                }}
              >
                &gt; News search
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "tweets_search", {});
                }}
              >
                &gt; Tweets search
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "correlate", {});
                }}
              >
                &gt; Correlate
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "reddit_search", {});
                }}
              >
                &gt; Reddit
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "reactions", {});
                }}
              >
                &gt; Reactions
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "twitter_realtime", {});
                }}
              >
                &gt; Twitter Real-time
              </a>
            </li>

            <Break />

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "timeline", {});
                }}
              >
                &gt; Timeline
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "clearcross", {});
                }}
              >
                &gt; ClearCross
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "halts", {});
                }}
              >
                &gt; Halts
              </a>
            </li>

            {isFullAccess && (
              <>
                <Break />
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(
                        props.containerApi,
                        "twitter_notifications",
                        {},
                      );
                    }}
                  >
                    &gt; Twitter notifications
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "expressions", {});
                    }}
                  >
                    &gt; Keyword tracer
                  </a>
                </li>
              </>
            )}

            <Break />

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "calendar", {});
                }}
              >
                &gt; Calendar
              </a>
            </li>

            <li>
              <a
                href="/"
                onClick={(e) => {
                  e.preventDefault();
                  addFloatingPanel(props.containerApi, "event_candidates", {});
                }}
              >
                &gt; Event candidates
              </a>
            </li>

            {isFullAccess && (
              <>
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "brsn_library", {});
                    }}
                  >
                    &gt; Library
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "realtime_notes", {});
                    }}
                  >
                    &gt; Realtime notes
                  </a>
                </li>
                <Break />
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "ibkr", {});
                    }}
                  >
                    &gt; IBKR
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "ibkr_chat", {});
                    }}
                  >
                    &gt; IBKR chat
                  </a>
                </li>
              </>
            )}
          </ul>
        </nav>

        {isFullAccess && (
          <>
            <h1>Simulate</h1>
            <nav>
              <ul>
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "simulate_watchlist", {});
                    }}
                  >
                    &gt; Watchlist
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "simulated_chart", {});
                    }}
                  >
                    &gt; Simulated chart
                  </a>
                </li>
                <li>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      addFloatingPanel(props.containerApi, "zhs_booking", {});
                    }}
                  >
                    &gt; ZHS Booking
                  </a>
                </li>
              </ul>
            </nav>
          </>
        )}
      </div>

      <BottomRevealTray />
    </div>
  );
};

const Break = () => <hr className="h-2 w-64" />;

export default Main;
